import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './contextual-help-link.css';

interface ContextualHelpLinkProps {
  docId: string;
  /** Link label. Defaults to "Learn more in Help". */
  children?: React.ReactNode;
  className?: string;
}

const ContextualHelpLink: React.FC<ContextualHelpLinkProps> = ({ docId, children, className = '' }) => {
  const { t } = useTranslation('help');
  const label = children ?? t('learnMoreInHelp');

  return (
    <Link to={`/help?tab=docs#${docId}`} className={`contextual-help-link ${className}`.trim()}>
      {label}
    </Link>
  );
};

export default ContextualHelpLink;
